import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { SwUpdate } from '@angular/service-worker';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  showUpdateReady: boolean = false;
  protected readonly location = location;
  isNltrPresent: boolean = false;

  constructor(
    private primengConfig: PrimeNGConfig,
    private update: SwUpdate,
    private route: ActivatedRoute,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    this.gtmService.pushTag({});
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.route.queryParams.subscribe((params) => {
      if (params['nltr']) {
        this.isNltrPresent = true;
        if (!params['ngsw-bypass']) {
          this.router
            .navigate([], {
              relativeTo: this.route,
              queryParams: { nltr: params['nltr'], 'ngsw-bypass': true },
            })
            .then(() => {
              window.location.reload();
            });
        }
      }
    });
  }

  ngAfterViewInit() {
    this.updateClient();
  }

  updateClient() {
    if (!this.update.isEnabled) {
      return;
    }
    this.update.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.showUpdateReady = true;
      }
    });
  }
}
